/**
 * Utilities for managing "Keep me logged in" preference for SSO users
 */

const KEEP_LOGGED_IN_KEY = 'keepMeLoggedIn'

/**
 * Set the "keep me logged in" preference
 */
export const setKeepLoggedIn = (enabled: boolean): void => {
  if (enabled) {
    localStorage.setItem(KEEP_LOGGED_IN_KEY, 'true')
  } else {
    localStorage.removeItem(KEEP_LOGGED_IN_KEY)
  }
}

/**
 * Get the "keep me logged in" preference
 */
export const getKeepLoggedIn = (): boolean => localStorage.getItem(KEEP_LOGGED_IN_KEY) === 'true'

/**
 * Clear the preference
 */
export const clearKeepLoggedIn = (): void => {
  localStorage.removeItem(KEEP_LOGGED_IN_KEY)
}

/**
 * Check if user is SSO user from JWT
 */
export const isSsoUser = (token?: string): boolean => {
  if (!token) return false

  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.user_type === 'sso' || payload.user_type === 'internal'
  } catch (e) {
    return false
  }
}

/**
 * Extract email from JWT
 */
export const getEmailFromJWT = (token?: string): string | null => {
  if (!token) return null

  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.email || null
  } catch (e) {
    console.error('[Keep Logged In] Failed to extract email from JWT:', e)
    return null
  }
}
